export default {
    name: "PigmentCodeImage",
    props: {},
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {},
    methods: {}
}
